import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { CreateExpertStripeOnboardingLinkDocument } from '~/graphql/mutations/expertStripeConnect';

export interface UseExpertStripeOnboardingLinkResult {
  /** Requests an Account Link URL from the API and returns it (caller may redirect). */
  getOnboardingUrl: () => Promise<string | null>;
  isLoading: boolean;
}

/**
 * Stripe Connect Express onboarding: backend returns a one-time Account Link URL.
 */
export function useExpertStripeOnboardingLink(): UseExpertStripeOnboardingLinkResult {
  const [createExpertStripeOnboardingLinkMutation, { loading }] = useMutation(
    CreateExpertStripeOnboardingLinkDocument,
  );

  const getOnboardingUrl = useCallback(async (): Promise<string | null> => {
    const { data } = await createExpertStripeOnboardingLinkMutation();
    return data?.createExpertStripeOnboardingLink ?? null;
  }, [createExpertStripeOnboardingLinkMutation]);

  return { getOnboardingUrl, isLoading: loading };
}
